export enum LessorType {
  Social = "Social",
  Private = "Privé",
}
